import axios from "axios";
import { apiService } from "./api.service";
import { extractData, handleApiException, handleResponse } from "helpers/apiResponseHelper";
import { CustomerEleringAuthorization, CustomerNavirecAccount } from "models/customer";
import { CustomerRepresentatives } from "models/customer-representative";

async function getEleringAuthorization(customerEic: string, meteringPointEics : string[]) : Promise<CustomerEleringAuthorization> {
  return axios
    .get(`${apiService.getApiUrl()}/customers/eic/${customerEic}/elering-authorization?meteringPointEics=${meteringPointEics}`)
    .then(handleResponse)
    .then(extractData)
    .catch(handleApiException);
}

async function findNavirecAccounts(customerId: number, token: string) : Promise<CustomerNavirecAccount[]> {
  return axios
    .get(`${apiService.getApiUrl()}/customers/${customerId}/navirec/accounts?token=${token}`)
    .then(handleResponse)
    .then(extractData)
    .catch(handleApiException);
}

async function getRepresentatives(customerId: number) : Promise<CustomerRepresentatives> {
  return axios
    .get(`${apiService.getApiUrl()}/customers/${customerId}/representatives`)
    .then(handleResponse)
    .then(extractData)
    .catch(handleApiException);
}

const CustomerService = {
  getEleringAuthorization,
  findNavirecAccounts,
  getRepresentatives
};

export default CustomerService;
